export const INVOICE_CREATION_TYPES = {
	VAT_ID: 'vat_id',
	COMPANY_ID: 'company_id',
	OLD_WAY: 'old_way',
	PHYSICAL_PERSON: 'physical_person',
	NOT_SET: '',
};
